<div class="container" style="padding-top: 15px; min-height: 300px">
  <div class="row" style="padding-bottom: 10px">
    <div class="col-md-10"></div>
    <div class="col-md-2">
      <button mat-raised-button class="piButton" (click)="createPreFilter()">New Pre Filter</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2 mainLabel"></div>
    <div class="col-md-5 mainLabel">Pre Filter Name</div>
    <div class="col-md-5 mainLabel">Owner</div>
  </div>
  <ng-container *ngFor="let preFilter of preFilters">
    <div class="row table-row">
      <div class="col-md-2">
        <ng-container *ngIf="preFilter.allowEdit">
          <a href="#" (click)="editPreFilter(preFilter)"><span class="fas fa-edit" title="Edit"></span></a>&nbsp;
        </ng-container>
        <ng-container *ngIf="preFilter.owner">
          <a href="#" (click)="deletePreFilter(preFilter)"><span class="fas fa-trash" title="Delete"></span></a>&nbsp;
        </ng-container>
      </div>
      <div class="col-md-5">{{preFilter.name}}</div>
      <div class="col-md-5">{{preFilter.createdBy}}</div>
    </div>
  </ng-container>
</div>
